










import Vue from 'vue'
import Component from 'vue-class-component'

@Component({})
export default class BasePage extends Vue {
  mounted () {
    document.body.style.overflowY = 'scroll'
  }
}
